var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invite-take"},[_vm._v("\n  免费下载此图&获取更多免费下载\n  "),_c('div',{staticClass:"take",on:{"click":_vm.navigatorTo}},[_vm._v("点此获取\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }